import { makeHttpRequest } from "@/shared";

export const deleteInventoryPrices = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "/inventory/price/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;

    return response;
};
